
import moment from "moment";
import { useDispatch } from "react-redux";
import styled from "styled-components"
import { setMarkerFilterEndDate, setMarkerFilterStartDate } from "../../../../features/topPagesMap/topPagesMapSlice";

const Container = styled.div`
    border: 1px solid ${({theme}) => theme.mainTextColor};
    border-radius: 5px;
    padding: 5px;
    display: flex;
    justify-content: center;

    input{
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-lg);

    }

`

const FilterDateInput = ({data, limit, type}) => {

  const dispatch = useDispatch()
  const handleChange = (value) => {
    if(type === "start"){
      if(moment(value).isBefore(limit)){
        dispatch(setMarkerFilterStartDate(limit))
      }
      else{
        dispatch(setMarkerFilterStartDate(value))
      }
    }

    else{
      if(moment(value).isAfter(limit)){
        dispatch(setMarkerFilterEndDate(limit))
      }
      else{
        dispatch(setMarkerFilterEndDate(value))
      }
    }
  }
  
  return (
    <Container>
        <input
        type="datetime-local"
        value={data || limit}
        onChange={(e) => handleChange(e.target.value)}
        min={limit}
        />
    </Container>
  )
}

export default FilterDateInput